import { render, staticRenderFns } from "./PaxelMarketMainFeatures.vue?vue&type=template&id=2aa4c8ac&"
import script from "./PaxelMarketMainFeatures.vue?vue&type=script&lang=js&"
export * from "./PaxelMarketMainFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports